"use strict";
/**
 * @file Select Overlay
 * @desc 下拉浮层的内容，Select & MultiSelect 共用之
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsStyleOptionGroups = exports.OptionGroups = exports.Options = exports.hasAvailableOption = exports.Empty = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var ConfigProvider_1 = require("../ConfigProvider");
var icons_1 = require("../icons");
var Loading_1 = require("../Loading");
var Menu_1 = require("../Menu");
var Tabs_1 = tslib_1.__importStar(require("../Tabs"));
var utils_1 = require("../utils");
var common_1 = require("./common");
var context_1 = require("./context");
/** 没有可选项时的占位内容 */
function Empty() {
    var prefix = common_1.useSelectPrefix();
    var emptyText = ConfigProvider_1.useLangData('select').emptyText;
    return react_1.default.createElement("div", { className: utils_1.concat(prefix, 'empty') }, emptyText);
}
exports.Empty = Empty;
/** items 中是否有可选项 */
function hasAvailableOption(items) {
    return items.some(function (item) { return (!common_1.isGroup(item) || item.options.length > 0); });
}
exports.hasAvailableOption = hasAvailableOption;
/** 渲染 option 项的组件 */
function RealOption(_a) {
    var value = _a.value, disabled = _a.disabled, content = _a.content, rootHtmlProps = _a.rootHtmlProps;
    var _b = context_1.useSelectCtx(), selected = _b.selected, onSelect = _b.onSelect, multiple = _b.multiple;
    var active = selected.includes(value);
    var prefix = common_1.useSelectPrefix();
    var optionClassName = utils_1.concat(prefix, 'option');
    var handleClick = react_1.useCallback(function () {
        onSelect(multiple ? common_1.toggle(selected, value) : [value]);
    }, [value, selected, onSelect, multiple]);
    var checkedIcon = active && multiple && (react_1.default.createElement(icons_1.CheckIcon, { className: utils_1.concat(optionClassName, 'icon') }));
    return (react_1.default.createElement(Menu_1.MenuItem, { disabled: disabled, active: active, onClick: handleClick, rootHtmlProps: rootHtmlProps },
        react_1.default.createElement("span", { title: utils_1.getText(content), className: utils_1.concat(optionClassName, 'text') }, content),
        checkedIcon));
}
/** 渲染 option 组的组件 */
function RealOptionGroup(_a) {
    var title = _a.title, options = _a.options;
    var optionsView = options.map(function (option) { return (react_1.default.createElement(RealOption, tslib_1.__assign({ key: option.value }, option))); });
    return (react_1.default.createElement(Menu_1.MenuItemGroup, { title: title }, optionsView));
}
/** 在 Overlay 中渲染 `<Option>` 列表 */
function Options(_a) {
    var options = _a.options;
    var size = context_1.useSelectCtx().size;
    var optionsView = options.map(function (option) { return (react_1.default.createElement(RealOption, tslib_1.__assign({}, option, { key: option.value }))); });
    return react_1.default.createElement(Menu_1.Menu, { size: size }, optionsView);
}
exports.Options = Options;
/** 在 Overlay 中渲染 `<OptionGroup>` 列表 */
function OptionGroups(_a) {
    var groups = _a.groups;
    var size = context_1.useSelectCtx().size;
    var optionGroupsView = groups.map(function (group, i) { return (react_1.default.createElement(RealOptionGroup, { key: i, title: group.title, options: group.options })); });
    return react_1.default.createElement(Menu_1.Menu, { size: size }, optionGroupsView);
}
exports.OptionGroups = OptionGroups;
/** 在 Overlay 中渲染 `<OptionGroup>` 列表（使用 Tabs 样式） */
function TabsStyleOptionGroups(_a) {
    var groups = _a.groups;
    var prefix = common_1.useSelectPrefix();
    var tabsClz = utils_1.concat(prefix, 'option-group-tabs');
    var size = context_1.useSelectCtx().size;
    var tabPanes = groups.map(function (group, i) { return (react_1.default.createElement(Tabs_1.TabPane, { className: utils_1.concat(tabsClz, 'tab-pane'), key: i, name: group.title, value: i },
        react_1.default.createElement(Menu_1.Menu, { className: utils_1.concat(tabsClz, 'tab-pane-content'), size: size }, group.options.map(function (option) { return (react_1.default.createElement(RealOption, tslib_1.__assign({}, option, { key: option.value }))); })))); });
    // select size: default / large 对应 tabs size: default
    var tabsSize = size === 'small' ? 'small' : 'default';
    return (react_1.default.createElement(Tabs_1.default, { className: tabsClz, size: tabsSize }, tabPanes));
}
exports.TabsStyleOptionGroups = TabsStyleOptionGroups;
/** 下拉浮层的内容，TODO: 支持键盘操作 */
function Overlay(_a) {
    var wrapperRef = _a.wrapperRef, items = _a.items, loading = _a.loading, groupStyle = _a.groupStyle;
    var prefix = common_1.useSelectPrefix();
    var options = [];
    var optionGroups = [];
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        if (common_1.isGroup(item))
            optionGroups.push(item);
        else
            options.push(item);
    }
    // 检查是否混用了 <Option> & <OptionGroup>
    if (options.length > 0 && optionGroups.length > 0) {
        throw new Error('Unexpected mix of `<Option>` & `<OptionGroup>`.');
    }
    var content = (function () {
        if (!hasAvailableOption(items))
            return react_1.default.createElement(Empty, null);
        if (optionGroups.length > 0) {
            if (groupStyle === 'tabs')
                return react_1.default.createElement(TabsStyleOptionGroups, { groups: optionGroups });
            return react_1.default.createElement(OptionGroups, { groups: optionGroups });
        }
        return react_1.default.createElement(Options, { options: options });
    })();
    return (react_1.default.createElement(Loading_1.Loading, { childrenVisibility: "hidden", loading: loading },
        react_1.default.createElement("div", { ref: wrapperRef, className: utils_1.concat(prefix, 'overlay') }, content)));
}
exports.default = Overlay;
//# sourceMappingURL=Overlay.js.map